import { SVGProps } from 'react';
const Positive = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={15}
    height={8}
    fill='none'
    {...props}
  >
    <path
      fill='#37863D'
      d='M2.053 7.875h11.645c1.047 0 1.57-1.221.831-1.933L8.707.332a1.2 1.2 0 0 0-1.659 0l-5.827 5.61c-.74.712-.216 1.933.832 1.933Z'
    />
  </svg>
);
export default Positive;
